const bannerAndDrawer = () => {
    const banners = document.querySelectorAll('[ data-banner-and-drawer]');
    banners.forEach((banner) => {
        const toggles = banner.querySelectorAll('[data-drawer-toggle]');
        const overlay = banner.querySelector('[data-drawer-overlay]');
        const drawer = banner.querySelector('[data-drawer]');
        toggles.forEach((toggle) => {
            toggle.addEventListener('click', () => {
                document.body.classList.toggle('overflow-hidden');
                drawer.classList.toggle('banner-drawer__drawer--visible');
                overlay.classList.toggle('banner-drawer__drawer-overlay--visible');
            });
        });
    });
};
export { bannerAndDrawer };
